import { getMixtureConfig } from '../View/exportComponent';
const mixtureChannelId = process.env.MIXTURE_CHANNEL_ID;
const mixtureGraphQLApi = process.env.MIXTURE_CATALOG_GRAPHQL_API;
const MIXTURE_CONFIG= getMixtureConfig();

export function getCatlogQuery(mode) {
    const CATALOG_QUERY = `
    {
        campaigns(campaignIds: [${MIXTURE_CONFIG[mode]['MIXTURE_CHAMPAIGN_ID']}]) {
            campaignId
            startDate
            name {
                    locale 
                    value
                }
            consumerActions {
                trait {
                    id
                    name
                    desc
                }
                optIn {
                    id
                    text {
                        locale
                        value
                    }
                }
            }
            }
    }
    `;

    return CATALOG_QUERY;
}


export const mixtureGraphQL = async (mode) => {
    try {
        const response = await fetch(mixtureGraphQLApi, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "channelId": mixtureChannelId
            },
            body: JSON.stringify({ query: getCatlogQuery(mode) })
        });

        if (!response.ok) {
            throw new Error('error')
        }
        const data = await response.json();
        return data?.data?.campaigns?.length > 0 && data?.data?.campaigns[0];
    } catch (error) {
        throw error;
    }
} 
